import { createSelector } from 'reselect';
import { SECTION_TYPES } from '../../../constants';
import { IGamesCategory } from '../../../types';
import { getGames } from '../../../utils';
import { useGamesSelector } from '../../store';
import { GamesStorageType } from '../../types';

export const selectCategories = (categories: IGamesCategory[]) =>
  createSelector(
    (state: GamesStorageType) => state.games.data ?? {},
    (gamesData) =>
      categories
        .map(
          ({
            id,
            title,
            games: categoryGames,
            instantGames: wideCategoryGames,
            logo,
            logoActive
          }) => {
            return {
              type: SECTION_TYPES.CATEGORY_GENERAL,
              id,
              title,
              logo,
              logoActive,
              categoryGames: getGames(categoryGames, gamesData),
              wideCategoryGames: getGames(wideCategoryGames, gamesData)
            };
          }
        )
        .filter(({ categoryGames }) => categoryGames.length > 0)
  );

export const useGetPreparedCategories = (categories: IGamesCategory[]) => {
  return useGamesSelector(selectCategories, [categories]);
};
